import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import 'core-js/modules/es.array.find-last';
import 'core-js/modules/es.array.find-last-index';
import countryListOptions from '@/lists/countryList.js';
import agentListOptions from '@/lists/agentList.js';

import router from './router';
import store from './store';

// Styles
import '@/scss/style.scss';
// Plugins
import vuetify from '@/plugins/vuetify';

const app = createApp(App);

app.config.globalProperties.$store = store;

app
  .use(store)
  .use(vuetify)
  .provide('countryListOptions', countryListOptions)
  .provide('agentsOptions', agentListOptions)
  .use(router)
  .mount('#app');
